import { Icon } from 'packages/eid-icons'
import { Box, styled } from '@mui/material'
import { Tooltip } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const StyledIcon = styled(Icon)(({ theme }) => ({
    color: '#FF7E00',
    '&:hover': {
        '& g': { fill: '#FF7E00 !important' },
        color: '#ffffff',
    },
}))

const ConnectSwitch = ({ attribute, data }) => {
    const { t } = useTranslation()

    return (
        <Tooltip title={t('Common_Requestable')}>
            <Box display="flex" alignItems="center" justifyContent="center">
                <StyledIcon name="ConnectSwitch" />
            </Box>
        </Tooltip>
    )
}

export default ConnectSwitch
